import _ from "lodash";
import React from "react";
import client from "lib/apolloClient/client";
import {
  AttendanceManager3D,
  ClipboardTick3D,
  HeadHeart3D,
  IbPolicy3D,
  ServiceLearning3D,
  Analytics3D,
  ProgressSummary3D,
  Timetable3D,
  Announcements3D,
  Workbook3D,
  Journal3D,
  ClipboardCycle3D,
  Files3D,
  IbAandE3D,
  BookAtomViolet3D,
  Document3D,
  CommunityProject3D,
  PersonalProject3D,
  ReflectiveProject3D,
  Cas3D,
  Goals3D,
  FamilyCommunication3D,
  StudentProfile3D,
  ServiceAsAction3D,
  BookAtomBlue3D,
  Mail3D,
  Transcripts3D,
  StaffPermissions3D,
  Settings3D,
  Deadlines3D,
  Student3D,
  Family3D,
  AiTutor3D,
  Projects3D,
  Sync3D,
  ClassroomReview3D,
  ClipboardList3D,
  BookStackVertical3D,
} from "@toddle-edu/ds-icons";
import ACLStore from "lib/aclStore";

import { getProductUpdateModulesQuery } from "ProductUpdatesV2/modules/ProductUpdatesV2Queries";

const AVAILABLE_ON_REQUEST_BETA = "AVAILABLE_ON_REQUEST_BETA";

export const getIsAllowBetaFeatureRequestEnabled = () => {
  return ACLStore.can("Common:AllowBetaFeatureRequest");
};

export const getModuleIcon = ({ moduleKey }) => {
  switch (moduleKey) {
    case "ASSIGNMENTS":
      return {
        icon: <ClipboardTick3D />,
        color: "var(--teal-900)",
      };
    case "BEHAVIOUR_MANAGEMENT":
      return {
        icon: <HeadHeart3D />,
        color: "var(--violet-900)",
      };
    case "SCHOOL_POLICY_AND_RESOURCES":
      return {
        icon: <IbPolicy3D />,
        color: "var(--teal-900)",
      };
    case "TEACHER_RESOURCES":
      return {
        icon: <IbPolicy3D />,
        color: "var(--teal-900)",
      };
    case "SERVICE_LEARNING":
      return {
        icon: <ServiceLearning3D />,
        color: "var(--orange-900)",
      };
    case "PROGRESS_REPORT":
      return {
        icon: <ProgressSummary3D />,
        color: "var(--teal-900)",
      };
    case "INSIGHTS":
      return {
        icon: <Analytics3D />,
        color: "var(--purple-900)",
      };
    case "TIMETABLE":
      return {
        icon: <Timetable3D />,
        color: "var(--orange-900)",
      };
    case "ANNOUNCEMENT":
      return {
        icon: <Announcements3D />,
        color: "var(--pink-900)",
      };
    case "WORKBOOK":
      return {
        icon: <Workbook3D />,
        color: "var(--orange-900)",
      };
    case "WORKSHEET":
      return {
        icon: <ClipboardList3D />,
        color: "var(--pink-900)",
      };
    case "ATTENDANCE":
      return {
        icon: <AttendanceManager3D />,
        color: "var(--yellow-900)",
      };
    case "CLASS_PORTFOLIO":
      return {
        icon: <Journal3D />,
        color: "var(--blue-900)",
      };
    case "CLASS_MATERIALS":
      return {
        icon: <ClipboardCycle3D />,
        color: "var(--yellow-900)",
      };
    case "CLASS_FILES":
      return {
        icon: <Files3D />,
        color: "var(--teal-900)",
      };
    case "GOAL":
      return {
        icon: <Goals3D />,
        color: "var(--blue-900)",
      };
    case "TODDLE_CONNECT":
    case "FAMILY_MESSAGING":
      return {
        icon: <FamilyCommunication3D />,
        color: "var(--green-900)",
      };
    case "STUDENT_PROFILE":
      return {
        icon: <StudentProfile3D />,
        color: "var(--pink-900)",
      };
    case "AUTH_AND_EVAL":
      return {
        icon: <IbAandE3D />,
        color: "var(--orange-900)",
      };
    case "WEEKLY_PLANNERS":
    case "GROUP_4_PROJECT":
    case "UNIT_PLANNING":
      return {
        icon: <BookAtomViolet3D />,
        color: "var(--violet-900)",
      };
    case "TOK_ESSAY":
      return {
        icon: <Document3D />,
        color: "var(--violet-900)",
      };
    case "TOK_EXHIBITION":
      return {
        icon: <CommunityProject3D />,
        color: "var(--orange-900)",
      };
    case "EXTENDED_ESSAY":
    case "PERSONAL_PROJECT":
      return {
        icon: <PersonalProject3D />,
        color: "var(--pink-900)",
      };
    case "REFLECTIVE_PROJECT":
    case "COMMUNITY_PROJECT":
      return {
        icon: <ReflectiveProject3D />,
        color: "var(--violet-900)",
      };
    case "SERVICE_AS_ACTION":
      return {
        icon: <ServiceAsAction3D />,
        color: "var(--blue-900)",
      };
    case "COLLABORATIVE_SCIENCE_PROJECT":
      return {
        icon: <BookAtomBlue3D />,
        color: "var(--blue-900)",
      };
    case "CREATIVITY_ACTIVITY_SERVICE":
      return {
        icon: <Cas3D />,
        color: "var(--yellow-900)",
      };
    case "NOTIFICATION":
      return {
        icon: <Mail3D />,
        color: "var(--yellow-900)",
      };
    case "TRANSCRIPT":
    case "GRADEBOOK":
      return {
        icon: <Transcripts3D />,
        color: "var(--orange-900)",
      };
    case "AI_TUTOR":
      return {
        icon: <AiTutor3D />,
        color: "var(--violet-900)",
      };
    case "ROLES_AND_PERMISSION":
      return {
        icon: <StaffPermissions3D />,
        color: "var(--teal-900)",
      };
    case "ADMIN_PORTAL":
      return {
        icon: <Settings3D />,
        color: "var(--blue-900)",
      };
    case "CALENDAR":
      return {
        icon: <Deadlines3D />,
        color: "var(--pink-900)",
      };
    case "PROJECTS":
      return {
        icon: <Projects3D />,
        color: "var(--green-900)",
      };
    case "STUDENT_APP":
      return {
        icon: <Student3D />,
        color: "var(--blue-900)",
      };
    case "FAMILY_APP":
      return {
        icon: <Family3D />,
        color: "var(--pink-900)",
      };
    case "INTEGRATIONS":
      return {
        icon: <Sync3D />,
        color: "var(--blue-900)",
      };
    case "EDUCATOR_APP":
    case "CLASS_FLOW":
      return {
        icon: <ClassroomReview3D />,
        color: "var(--pink-900)",
      };
    case "USER_EXPERIENCE_IMPROVEMENTS":
      return {
        icon: <Document3D />, // need to change
        color: "var(--violet-900)",
      };
    case "ACADEMIC_SETUP":
      return {
        icon: <Student3D />,
        color: "var(--blue-900)",
      };
    case "IBIS_REGISTRATION":
      return {
        icon: <IbPolicy3D />,
        color: "var(--teal-900)",
      };
    case "COURSES":
      return {
        icon: <BookStackVertical3D />,
        color: "var(--orange-900)",
      };
    default:
      return {
        icon: <Document3D />,
        color: "var(--violet-900)",
      };
  }
};

/**
 * Get product update modules from Apollo cache
 * @param {Object} variables - Query variables
 * @returns {Object} Product update modules data or empty object
 */
export const getProductUpdateModulesFromCache = variables => {
  let queryData = {};
  const { filters = { fetchAll: false } } = variables || {};

  try {
    queryData = client.readQuery({
      query: getProductUpdateModulesQuery,
      variables: { filters },
    });
    return _.get(queryData, "cms.modules", []);
  } catch (e) {
    return {};
  }
};

export const getFeatureAvailableForRequest = ({ releaseItems }) => {
  return _.some(releaseItems, releaseItem =>
    _.some(
      _.get(releaseItem, "categories"),
      category => _.get(category, "type") === AVAILABLE_ON_REQUEST_BETA
    )
  );
};
